import React from 'react';
export default function RainBootsSvg({ size = 40 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8 10V30H4V34H18V30H14V10H8Z" fill="#FFEB3B" />
      <path d="M26 10V30H22V34H36V30H32V10H26Z" fill="#FFEB3B" />
      <rect x="8" y="10" width="6" height="3" fill="#FDD835" />
      <rect x="26" y="10" width="6" height="3" fill="#FDD835" />
      <circle cx="11" cy="20" r="1" fill="#FFF" opacity="0.4" />
      <circle cx="29" cy="22" r="1" fill="#FFF" opacity="0.4" />
    </svg>
  );
}
